import { services } from '@billow/js-helpers'
import { get, post } from './request'

/**
 * Load the currently authenticated user.
 * Returns 401 on failure.
 * @param {Function} success
 * @param {Function} failure
 */

export let load = (success, failure) => get(
  `api/user`, success, failure
)

export let login = (user, success, failure) => post(
  `/oauth/token`,
  services.auth.passportLoginPayload(user),
  response => success(response),
  error => failure(error)
)

export let loadUser = (success, failure) => {
  return get(
    `/api/user`,
    response => success(response),
    error => failure(error)
  )
}
